module.exports = __webpack_public_path__ + "static/img/donate-blood-01.4145962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/donate-blood-01.jpg
// module id = dKQG
// module chunks = 100